import { useRef, useState } from "react";
import { useEscapeKey } from "src/hooks/dom/use-escape-key";

/**
 * Hook to manage a toggleable UI component with escape key support.
 * Returns a ref, open state, and control functions.
 */
export const useToggleWithAnchor = () => {
    const anchorRef = useRef<HTMLButtonElement | null>(null);
    const [open, setOpen] = useState(false);

    const toggleOpen = () => setOpen(prev => !prev);
    const close = () => setOpen(false);

    useEscapeKey({ callback: toggleOpen, enabled: open });

    return {
        anchorRef,
        isOpen: open,
        handleClose: close,
        handleClick: toggleOpen,
    };
};
